import { Mention as TiptapMention } from '@tiptap/extension-mention';
import { mergeAttributes } from '@tiptap/vue-3';
import { MentionSuggestion } from './MentionSuggestion';
import { PluginKey } from '@tiptap/pm/state';
import { default as Suggestion } from '@tiptap/suggestion';
import { doubleClickSelectPlugin } from '@/features/App/AppTextEditor/plugins/DoubleClickSelectPlugin';

export const Mention = TiptapMention.extend({
	selectable: true,
	addProseMirrorPlugins() {
		return [
			Suggestion({ editor: this.editor, ...this.options.suggestion }),
			doubleClickSelectPlugin.call(
				this,
				new PluginKey(TiptapMention.name)
			),
		];
	},
}).configure({
	HTMLAttributes: {
		class: 'mention mceNonEditable js-tinymce-user tinymce-user',
	},
	renderHTML(props) {
		const { options, node } = props;
		return [
			'span',
			mergeAttributes(options.HTMLAttributes, {
				'data-id': node.attrs.id,
				class: `user-${node.attrs.id}`,
			}),
			`${options.suggestion.char}${node.attrs.label ?? node.attrs.id}`,
		];
	},
	suggestion: MentionSuggestion,
});
